import axios from '../utils/axios';

export default function fetchJobVisibilityDetails(adminId, jobId, params) {
    
    return (
        axios.get('/admin/' + adminId + '/published-jobs/' + jobId , { params })
    )
}
